var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-list-group-item',{staticClass:"d-flex align-items-center mb-4 style-group"},[_c('b-avatar',{staticClass:"mr-3 avatar-style"}),_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',[_vm._v(_vm._s(_vm.defaultbio))])])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }